import { render, staticRenderFns } from "./PostUsers.vue?vue&type=template&id=080247ce&scoped=true"
import script from "./PostUsers.vue?vue&type=script&lang=js"
export * from "./PostUsers.vue?vue&type=script&lang=js"
import style0 from "./PostUsers.vue?vue&type=style&index=0&id=080247ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080247ce",
  null
  
)

export default component.exports